import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w100 pad20 with_white_bg mb20"
}
const _hoisted_2 = { class: "fs16" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "fs14 fl skyblue fw600 mt7" }, "▼ 日程候補を表示", -1)
const _hoisted_4 = { class: "fs18 arial fw600 fr" }
const _hoisted_5 = { class: "fs24 arial fw600" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 0,
  style: {"height":"300px"},
  class: "CandidatesContent SelectModalPds"
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "fs20 fw600 mt20 arial" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = { key: 1 }
const _hoisted_13 = {
  style: {"transform":"scale(0.5)"},
  class: "CalendarContent"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PossibleDateLi = _resolveComponent("PossibleDateLi")!
  const _component_CalendarTable = _resolveComponent("CalendarTable")!

  return (_ctx.pdm)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "pointer",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openDatesContent && _ctx.openDatesContent(...args)))
          }, [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.totalNum), 1),
              _createTextVNode("件 ")
            ])
          ]),
          _hoisted_6,
          (!_ctx.cm.astag.can_connect_calendar)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                (_ctx.Util.isPresent(_ctx.dailyDic) && _ctx.isOpenDates)
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_8, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dailyDic, (pds, pdsindex) => {
                        return (_openBlock(), _createElementBlock("div", { key: pdsindex }, [
                          (_ctx.Util.isPresent(pds[_ctx.cm.getOwnerUserId()].group_events_dic[`A`].possible_events))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.CalendarUtil.toJpFormatDate(
                                        pds[_ctx.cm.getOwnerUserId()].group_events_dic[`A`].possible_events[0].start_time
                                    )), 1),
                                _hoisted_11,
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pds[_ctx.cm.getOwnerUserId()].group_events_dic[`A`].possible_events, (pd, pdindex) => {
                                  return (_openBlock(), _createBlock(_component_PossibleDateLi, {
                                    key: `${pd.jp_format}${pd.selected}${pdindex}${_ctx.totalNum}`,
                                    showConfirmButton: false,
                                    useSelectbox: false,
                                    pd: pd,
                                    idprefix: `asview`,
                                    canDelete: true,
                                    onRemoveDate: _ctx.removeDate
                                  }, null, 8, ["pd", "onRemoveDate"]))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                (_ctx.Util.isPresent(_ctx.monthlyPossibleDates))
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(`centering mt20 ${_ctx.loading ? `op3` : ``}`),
                      style: {
                        height: `170px`,
                    }
                    }, [
                      _createElementVNode("section", _hoisted_13, [
                        _createVNode(_component_CalendarTable, {
                          ref: "CalendarTable",
                          monthlyPossibleDates: _ctx.monthlyPossibleDates,
                          idprefix: `asview`,
                          onSelectDateFromCal: _ctx.selectDateFromCal,
                          onClickPrevMonth: _ctx.clickPrevMonth,
                          onClickNextMonth: _ctx.clickNextMonth
                        }, null, 8, ["monthlyPossibleDates", "onSelectDateFromCal", "onClickPrevMonth", "onClickNextMonth"])
                      ])
                    ], 2))
                  : _createCommentVNode("", true)
              ]))
        ]),
        _hoisted_14
      ]))
    : _createCommentVNode("", true)
}